import axios from "axios";
import { url } from "./apiurl";

export const getDeals = () =>
  axios.get(url + "/deal", { withCredentials: true });
export const createDeal = (deal) =>
  axios.post(url + "/deal", deal, { withCredentials: true });
